module.exports = __webpack_public_path__ + "static/media/liveroom-setting-slider.054e46a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroomSetting/liveroom-setting-slider.png
// module id = 2045
// module chunks = 6